import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumbs from '../components/Breadcrumbs';

const Donate = () => {
  return (
    <div className="min-h-screen flex flex-col bg-charcoal-dark text-slate-200">
      <Header />
      <Breadcrumbs />
      
      <main id="main-content" className="flex-grow max-w-6xl mx-auto w-full px-4 md:px-8 py-12 relative">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[350px] h-[350px] bg-accent-purple/5 rounded-full blur-[100px] pointer-events-none z-0" />

        {/* Hero Section */}
        <section className="text-center mb-16 py-4 relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-hope-green/10 border border-hope-green/30 text-hope-green text-xs font-bold uppercase tracking-wider mb-4">
            <span aria-hidden="true">🏛️</span> Federally Recognized 501(c)(3) Non-Profit
          </div>

          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 uppercase tracking-tight leading-none font-display">
            Support <span className="text-banana-yellow glow-yellow">Not By Chance</span>
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-slate-400 max-w-3xl mx-auto leading-relaxed uppercase tracking-wider">
            Every donation feeds, protects, and sustains lives in Louisville and Shepherdsville, KY.
          </p>
          <p className="mt-4 text-xs text-slate-500 max-w-2xl mx-auto leading-relaxed">
            All donations are tax-deductible to the extent allowed by law. Receipts can be provided upon request by emailing{' '}
            <a href="mailto:info@notbychanceoutreach.com" className="text-banana-yellow font-bold hover:underline">
              info@notbychanceoutreach.com
            </a>.
          </p>
        </section>

        {/* Donation Options Grid */}
        <section className="mb-16 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            
            {/* Venmo */}
            <div className="chrome-panel border border-white/5 rounded-lg p-6 hover:scale-[1.01] transition-transform duration-300 flex flex-col justify-between">
              <div className="text-center">
                <span className="bg-accent-cyan/20 text-accent-cyan font-bold text-xs uppercase tracking-wider px-2 py-1 rounded mb-4 inline-block">Tap or Scan</span>
                <a
                  href="https://www.paypal.com/qrcodes/venmocs/db1a6d8a-7f08-4756-af61-7db04451dd49?created=1784029725"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cyber-btn-blue text-xs w-full inline-block py-2 mb-4 text-center font-bold"
                >
                  Venmo Donation
                </a>
                
                <div className="mb-6 flex justify-center">
                  <img
                    src="/venmo.jpg"
                    alt="Venmo QR Code"
                    className="w-full max-w-[200px] h-auto rounded-lg shadow-[0_0_15px_rgba(255,255,255,0.05)] border border-white/10"
                  />
                </div>
                
                <div className="text-left space-y-2">
                  <p className="text-white font-bold text-sm uppercase">Instructions:</p>
                  <ol className="text-slate-400 space-y-1 text-xs list-decimal list-inside">
                    <li>Scan QR with phone, or</li>
                    <li>Click the link button above</li>
                    <li>Note: <span className="text-white font-semibold">"Donation"</span></li>
                  </ol>
                </div>
              </div>
              <p className="text-[10px] text-slate-500 mt-4 pt-4 border-t border-white/5 text-center">
                Convenient and fast mobile donation.
              </p>
            </div>

            {/* PayPal */}
            <div className="chrome-panel border border-white/5 rounded-lg p-6 hover:scale-[1.01] transition-transform duration-300 flex flex-col justify-between">
              <div className="text-center">
                <span className="bg-accent-purple/20 text-accent-purple font-bold text-xs uppercase tracking-wider px-2 py-1 rounded mb-4 inline-block">Tap or Scan</span>
                <a
                  href="https://www.paypal.com/ncp/payment/PEB48N6224YW8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cyber-btn-purple text-xs w-full inline-block py-2 mb-4 text-center font-bold"
                >
                  PayPal Donation
                </a>
                
                <div className="mb-6 flex justify-center">
                  <img
                    src="/paypal.png"
                    alt="PayPal QR Code"
                    className="w-full max-w-[200px] h-auto rounded-lg shadow-[0_0_15px_rgba(255,255,255,0.05)] border border-white/10"
                  />
                </div>
                
                <div className="text-left space-y-2">
                  <p className="text-white font-bold text-sm uppercase">Instructions:</p>
                  <ol className="text-slate-400 space-y-1 text-xs list-decimal list-inside">
                    <li>Scan QR with phone, or</li>
                    <li>Click the link button above</li>
                    <li>Note: <span className="text-white font-semibold">"Donation"</span></li>
                  </ol>
                </div>
              </div>
              <p className="text-[10px] text-slate-500 mt-4 pt-4 border-t border-white/5 text-center">
                Secure transaction processed by PayPal.
              </p>
            </div>

          </div>
        </section>

        {/* Footer Disclaimer */}
        <section className="chrome-panel border border-white/5 rounded-lg p-6 md:p-8 mb-8 relative z-10">
          <h2 className="text-xl font-bold text-white uppercase tracking-tight mb-4">Important Information</h2>
          <div className="space-y-4 text-sm text-slate-400 leading-relaxed">
            <p>
              Not By Chance Inc. is a federally recognized 501(c)(3) non-profit organization. All donations are tax-deductible to the extent allowed by law, and we can provide receipts upon request via email at <a href="mailto:info@notbychanceoutreach.com" className="text-banana-yellow hover:underline font-bold">info@notbychanceoutreach.com</a>. Thank you for your generosity and support!
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Donate;

